import { AudioConnection } from "./AudioConnection";
import { AudioGraphNode } from "./nodes/AudioGraphNode";
import { Gain } from "./nodes/Gain";
import { BiquadFilter } from "./nodes/BiquadFilter";
import { DynamicsCompressor } from "./nodes/DynamicsCompressor";
import { MediaElementAudioSource } from "./nodes/MediaElementAudioSource";
import { EventSlot } from "../../events/EventSlot";

export class AudioGraph
{
  private static _instance:AudioGraph;
  
  static get $()
  {
    if ( AudioGraph._instance )
    {
      return AudioGraph._instance
    }

    AudioGraph._instance = new AudioGraph();

    return AudioGraph._instance
  }

  private _context:AudioContext = null;
  get context(){ return this._context; }
  private _ready = false;
  get ready(){ return this._ready; }
  private _nodes:AudioGraphNode<any>[] = [];
  private _nodeMap = new Map<number,AudioGraphNode<any>>();
  private _connections:AudioConnection[] = [];
  private _idCounter = 0;

  public readonly onReady = new EventSlot();

  private _nextID()
  {
    this._idCounter ++;
    return this._idCounter;
  }


  initialize()
  {
    if ( this._context )
    {
      return;
    }

    try
    {

      let AudioContextBase = window.AudioContext || ( window as any ).webkitAudioContext;
      this._context = new AudioContextBase();
      this._ready = true;
    }
    catch( e )
    {
      this._context = null;
      this._ready = false;
    }
    
    if ( ! this._ready )
    {
      return;
    }

    this._nodes.forEach( n => n.initialize() );
    this._connections.forEach( c => c.connect() );

    this.onReady.dispatch( {} );
  }

  close()
  {
    if  ( ! this._context )
    {
      return;
    }

    this._ready = false;
    this._context.close();
  }
  

  createConnection( fromID:number, toID:number, fromIndex:number=undefined, toIndex:number=undefined )
  {
    let connection = new AudioConnection( this, fromID, toID, fromIndex, toIndex );

    this._connections.push( connection );

    if ( ! this.ready )
    {
      return;
    }

    connection.connect();

    return connection;
  }

  getNode( id:number )
  {
    return this._nodeMap.get( id );
  }

  private _addAudioNode<T extends AudioGraphNode<any>>( node:T ):T
  {
    this._nodes.push( node );
    this._nodeMap.set( node.id, node );
    
    if ( this._ready )
    {
      node.initialize();
    }

    return node;
  }


  createGain()
  {
    return this._addAudioNode( new Gain( this, this._nextID() ) );
  }

  createMediaElementSource( audio:HTMLAudioElement )
  {
    return this._addAudioNode( new MediaElementAudioSource( this, this._nextID(), audio ) );
  }

  createBiquadFilter()
  {
    return this._addAudioNode( new BiquadFilter( this, this._nextID() ) );
  }
  
  createDynamicsCompressor()
  {
    return this._addAudioNode( new DynamicsCompressor( this, this._nextID() ) );
  }


}